<template>
  <div id="app">
    <TopBar class="app-top-bar"></TopBar>
  <!-- <keep-alive> -->
      <router-view />
  <!-- </keep-alive> -->
    <Footer></Footer>
    <login-name ref="loginName"></login-name>
  </div>
</template>

<script>
  import TopBar from "@/components/TopBar";
  import Footer from "@/components/footer";
  import LoginName  from '@/views/login/index.vue';
  export default {
    components: { TopBar, Footer,LoginName },
    data() {
      return {};
    },

    computed: {},

    watch: {},

    created() {
      if (this.$store.getters.token) this.$store.dispatch("user/getInfo");
    },

    methods: {},
  };
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  background-image: url("./assets/background_stream.jpg");
  background-size: 100%;
  padding: 0;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
  Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
}
#app,
html,
body {
  height: 100%;
  width: calc(100% - 0px);
    position: absolute;
  }
  .app-top-bar {
    position: sticky;
    top: 0;
    z-index: 99999;
  }

  :root {
    overflow-y: auto;
    overflow-x: auto;
  }

  :root body {
    position: absolute;
  }

body {
  width: 99vw;
}
// 解决弹出层没有滚动条，导致页面右边空白问题
.el-popup-parent--hidden {
  width: 100vw;
  overflow: scroll;
}

</style>
